import { useEffect } from 'react';
import { useMarketWebSocketSender } from './useMarketWebSocketSender.ts';
import { SubscriptionRequest, MsgTypeSubscriptionRequest } from '@/api/spec.ts';

interface UseMarketDataSubscriptionsOptions {
  chainId?: string | number;
  enabled?: boolean;
}

export function useMarketDataSubscriptions({ chainId, enabled = true }: UseMarketDataSubscriptionsOptions) {
  const { sendMessage } = useMarketWebSocketSender();

  useEffect(() => {
    if (enabled && chainId && sendMessage) {
      const streams: SubscriptionRequest = {
        mt: MsgTypeSubscriptionRequest,
        subs: [
          {
            stream: `heartbeat@${chainId}`,
            subscribe: true,
          },
          {
            stream: `market-config@${chainId}`,
            subscribe: true,
          },
          {
            stream: `market-state@${chainId}`,
            subscribe: true,
          },
          {
            stream: `funding@${chainId}`,
            subscribe: true,
          },
        ],
      };

      sendMessage<SubscriptionRequest>(streams);

      return () => {
        const unsubscribeStreams: SubscriptionRequest = {
          mt: MsgTypeSubscriptionRequest,
          subs: [
            {
              stream: `heartbeat@${chainId}`,
              subscribe: false,
            },
            {
              stream: `market-config@${chainId}`,
              subscribe: false,
            },
            {
              stream: `market-state@${chainId}`,
              subscribe: false,
            },
            {
              stream: `funding@${chainId}`,
              subscribe: false,
            },
          ],
        };
        sendMessage<SubscriptionRequest>(unsubscribeStreams);
      };
    }
  }, [chainId, enabled, sendMessage]);
}
